import Primary from '../layouts/Primary'
import { borrowRouters } from './borrows'
import { loanRouters } from './loan'
import { investRouters } from './invest'
import { referralRouters } from './referral'
import { accountRouters } from './account'
import { dashboardRouters } from './dashboard'
import { administrationRouters } from './administration'
import { settingRouters } from '@/routers/setting'
import { interestRateRouters } from '@/routers/interestRate'
import { unauthorizedRouters } from '@/routers/unauthorized'
import { profileScoringRouters } from '@/routers/profileScoring'

export const primaryRouters = {
  path: '/admin',
  name: 'primary',
  component: Primary,
  redirect: 'dashboard',
  children: [
    dashboardRouters,
    borrowRouters,
    loanRouters,
    investRouters,
    referralRouters,
    accountRouters,
    interestRateRouters,
    profileScoringRouters,
    settingRouters,
    administrationRouters,
    unauthorizedRouters
  ]
}
